
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function toggle(el, on) {
    if (!el) return;
    el.hidden = !on;
  }

  $$("[data-open-menu]").forEach((b) =>
    b.addEventListener("click", () => toggle($("[data-menu]"), true))
  );
  $$("[data-close-menu]").forEach((b) =>
    b.addEventListener("click", () => toggle($("[data-menu]"), false))
  );
  $$("[data-open-search]").forEach((b) =>
    b.addEventListener("click", () => {
      toggle($("[data-search]"), true);
      const input = $("[data-search] input[type=search]");
      if (input) input.focus();
    })
  );
  $$("[data-close-search]").forEach((b) =>
    b.addEventListener("click", () => toggle($("[data-search]"), false))
  );
  $$("[data-open-whatsapp]").forEach((b) =>
    b.addEventListener("click", () => toggle($("[data-whatsapp]"), true))
  );
  $$("[data-close-whatsapp]").forEach((b) =>
    b.addEventListener("click", () => toggle($("[data-whatsapp]"), false))
  );

  $$(".drawer").forEach((d) => {
    d.addEventListener("click", (e) => {
      if (e.target === d) d.hidden = true;
    });
  });

  const hero = $("[data-hero]");
  if (hero) {
    const slides = $$(".hero-slide", hero);
    const dots = $$("[data-hero-dots] button", hero);
    let i = 0;
    let paused = false;

    const show = (n) => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) =>
        s.classList.toggle("is-active", idx === i)
      );
      dots.forEach((d, idx) =>
        d.setAttribute("aria-current", idx === i ? "true" : "false")
      );
    };

    dots.forEach((d, idx) => d.addEventListener("click", () => show(idx)));

    const prev = $("[data-hero-prev]", hero);
    const next = $("[data-hero-next]", hero);

    if (prev) prev.addEventListener("click", () => show(i - 1));
    if (next) next.addEventListener("click", () => show(i + 1));

    hero.addEventListener("mouseenter", () => { paused = true; });
    hero.addEventListener("mouseleave", () => { paused = false; });

    const autoplay = hero.getAttribute("data-autoplay") !== "false";
    const interval = Number(hero.getAttribute("data-interval")) || 5000;

    if (autoplay && slides.length > 1) {
      setInterval(() => {
        if (!paused) show(i + 1);
      }, interval);
    }
  }

  $$("[data-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const main = $("[data-main-image]");
      if (main) main.src = btn.getAttribute("data-thumb");
      $$(".thumb").forEach((t) => t.classList.remove("is-active"));
      btn.classList.add("is-active");
    });
  });

  $$("[data-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn.parentElement.querySelector("input");
      if (!input) return;
      const delta = Number(btn.getAttribute("data-qty"));
      const next = Math.min(10, Math.max(1, Number(input.value || 1) + delta));
      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  const form = $(".product-form");
  if (form) {
    const productJson =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product;

    const optionInputs = $$("[data-option]", form);

    optionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        const selected = optionInputs
          .filter((i) => i.checked)
          .map((i) => i.value);

        const variants = productJson && productJson.variants;
        if (!variants) return;

        const match = variants.find((v) => {
          const options = v.options || [];
          return selected.every((val) => options.includes(val));
        });

        if (match) {
          const hidden = $("[data-variant-id]", form);
          if (hidden) hidden.value = match.id;
        }
      });
    });
  }

  const KEY = "naeem-wishlist";

  const readWish = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch (e) {
      return [];
    }
  };

  const writeWish = (list) => localStorage.setItem(KEY, JSON.stringify(list));

  const syncWish = () => {
    const list = readWish();

    $$("[data-wishlist-count]").forEach((el) => {
      el.hidden = list.length === 0;
      el.textContent = String(list.length);
    });

    $$("[data-wishlist-toggle]").forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");
      btn.classList.toggle("is-on", list.indexOf(handle) !== -1);
    });
  };

  $$("[data-wishlist-toggle]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const handle = btn.getAttribute("data-product-handle");
      let list = readWish();

      if (list.indexOf(handle) !== -1) {
        list = list.filter((h) => h !== handle);
      } else {
        list.push(handle);
      }

      writeWish(list);
      syncWish();
    });
  });

  syncWish();

  // WhatsApp order
  const waLink = $("[data-wa-send]");
  const waNumber = "923475039339";

  $$("[data-whatsapp-product]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const title = btn.getAttribute("data-title") || "";
      const price = btn.getAttribute("data-price") || "";
      const summary = $("[data-wa-summary]");

      if (summary) summary.textContent = title + " — " + price;

      toggle($("[data-whatsapp]"), true);

      if (waLink) {
        waLink.dataset.product = title + " (" + price + ")";
      }
    });
  });

  if (waLink) {
    waLink.addEventListener("click", async (e) => {
      e.preventDefault();

      const name = ($("[data-wa-name]") || {}).value || "";
      const phone = ($("[data-wa-phone]") || {}).value || "";
      const note = ($("[data-wa-note]") || {}).value || "";

      const lines = ["Hello Naeem Collections, I would like to order:"];

      if (name) lines.push("Name: " + name);
      if (phone) lines.push("Phone: " + phone);
      if (note) lines.push("City / Note: " + note);

      try {
        const response = await fetch("/cart.js", {
          headers: { Accept: "application/json" }
        });

        if (!response.ok) throw new Error("Unable to load cart");

        const cart = await response.json();

        if (cart.items && cart.items.length > 0) {
          lines.push("", "ORDER DETAILS:");

          cart.items.forEach((item) => {
            const variant =
              item.variant_title && item.variant_title !== "Default Title"
                ? " | Size/Variant: " + item.variant_title
                : "";

            const linePrice = (item.final_line_price / 100).toLocaleString(
              "en-PK",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            );

            lines.push(
              "• " + item.product_title +
              variant +
              " | Qty: " + item.quantity +
              " | Line total: " + (cart.currency || "PKR") + " " + linePrice
            );
          });

          const total = (cart.total_price / 100).toLocaleString("en-PK", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });

          lines.push(
            "",
            "Cart total: " + (cart.currency || "PKR") + " " + total,
            "",
            "Please confirm availability and delivery details."
          );
        } else {
          const product = waLink.dataset.product || "";
          if (product) {
            lines.push("", "Product: " + product);
          } else {
            lines.push("", "My cart is currently empty.");
          }
        }
      } catch (error) {
        const product = waLink.dataset.product || "";
        if (product) lines.push("", "Product: " + product);
        lines.push("", "Please confirm my order details.");
      }

      const url =
        "https://wa.me/" + waNumber + "?text=" +
        encodeURIComponent(lines.join("\n"));

      window.open(url, "_blank", "noopener");
    });
  }
})();
